import 'reflect-metadata';
export const HELP_METADATA_KEY = 'HELP_META';
// NOTE: use HelpDoc decorator on Routed components. Context sensitive help will search Route tree for a component with attached Helpmetadata.
export function HelpDoc(docPath) {
  return function SetHelpMetadata(ctor) {
    Reflect.defineMetadata(HELP_METADATA_KEY, {
      docPath
    }, ctor);
    return ctor;
  };
}
export function getHelpMetadata(ctor) {
  return Reflect.getMetadata(HELP_METADATA_KEY, ctor) || null;
}